import styles from './styles.module.css';

const DateTimeUpdateComponent = ({ publishedDate, modificatedAt, publishedMonthDayYear, modificatedMonthDayYear, publishedTimeHour, modificatedTimeHour }) => {
   const isPublishedDateSame = new Date(publishedDate).getTime() === new Date(modificatedAt).getTime();
    return <div className={`${styles['dateTime-container']}`}>
        <div className={`${styles['date-section']}`}>
            {
            !isPublishedDateSame
            && <div itemProp="datePublished" content={publishedDate}>
                {publishedMonthDayYear}
            </div>
            }
            {
            isPublishedDateSame
            &&     
            <time datetime={publishedDate}>{publishedMonthDayYear}</time>
            }

            <div className={`${styles['time-update']}`}>
                <span>&#160;{publishedTimeHour}</span>
            </div>
        </div>
        {
            !isPublishedDateSame
            && <>
                    <span className={`${styles['slash-separator']}`}>&nbsp;/&nbsp;</span>
                    <div className={`${styles['date-section']}`}>
                    <time class="modificatedDate" datetime={modificatedAt}> Actualizado al {modificatedMonthDayYear} {modificatedTimeHour}hs</time>
                    </div>
               </>
        }
    </div>
}

export default DateTimeUpdateComponent;